var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "formulate-input",
      attrs: {
        id: _vm.componentId,
        "data-classification": "text",
        "data-type": "text",
        "data-has-errors": "true",
        "data-is-showing-errors": "true",
      },
    },
    [
      _vm.descriptionHtml
        ? _c("div", { domProps: { innerHTML: _vm._s(_vm.descriptionHtml) } })
        : _vm._e(),
      _vm._v(" "),
      _vm.context.hasLabel
        ? _c(
            _vm.context.slotComponents.label,
            _vm._b(
              { tag: "component", attrs: { context: _vm.context } },
              "component",
              _vm.context.slotProps.label,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _c("FormulateInput", {
        attrs: {
          "remove-label": true,
          validation: _vm.validation,
          required: _vm.isRequired,
          "disable-errors": true,
          help: _vm.helpText,
          rows: _vm.textAreaRows,
          type: "textarea",
          "error-behavior": "live",
        },
        model: {
          value: _vm.textValue,
          callback: function ($$v) {
            _vm.textValue = $$v
          },
          expression: "textValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }